// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1y9QH","emails":"CreateEditClinics_emails__ufXlr","emailTagLabel":"CreateEditClinics_emailTagLabel__2cAtU"};